import { useState, useCallback } from "react";
import { putActiveSectionToDocumentURL } from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export function useUpdateSectionActive(token, section, refresh, close) {
  const [loading, setLoading] = useState(false);

  const handleRestore = useCallback(async () => {
    if (!section?.ID_SECCION) return;

    setLoading(true);
    try {
      const res = await fetch(putActiveSectionToDocumentURL(), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id_section: section.ID_SECCION,
          activo: 1,
        }),
      });
      if (!res.ok) {
        toastAlert("Error al restaurar la sección", "error");
        setLoading(false);
        return;
      }
      refresh();
      toastAlert("Sección restaurada correctamente", "success");
      close();
    } catch (err) {
      toastAlert("Error al restaurar la sección: " + err.message, "error");
    } finally {
      setLoading(false);
    }
  }, [token, section, refresh, close]);

  return { loading, handleRestore };
}
